/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {gsap, TimelineLite} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DeadwoodRip} from "../../game/DeadwoodRip";

export abstract class ContinueScreen extends PIXI.Container {

    protected _played:PIXI.Text;
    protected _continueButton:ContinueButton;
    protected _container:PIXI.Container;
    protected _layer:StageLayer;

    protected _continueCallback:() => void;

    constructor(layer:StageLayer) {
        super();
        this._layer = layer;
        this.visible = false;

        this._container = new PIXI.Container();
        this.addChild(this._container);

        this._continueButton = new ContinueButton();
        this._continueButton.enable(false);
        this._continueButton.visible = false;
        this._continueButton.resizeButtonToLabelWithMargin(18, 30, 18, 30);
        this._continueButton.addClickCallback(async () => {
            this._continueButton.enable(false);
            await Promise.resolve(this.close());
            if(this._continueCallback) {
                this._continueCallback();
            }
        });
        this.addChild(this._continueButton);

        layer.addChild(this);
        this.onOrientationChanged();
    }

    public onOrientationChanged() {
        if(NolimitApplication.isLandscape) {
            this._continueButton.position.set(360 - this._continueButton.width * 0.5, 615);
        } else {
            const centerBottom = (NolimitApplication.screenBounds.bottom - 610) * 0.5 + 610;
            this._continueButton.position.set(360 - this._continueButton.width * 0.5, centerBottom);
        }
        if(this._played) {
            this._played.position.set(360, this._continueButton.y - 30);
        }
    }

    public show(onContinueCallBack:() => void):TimelineLite {
        SlotGame.keypadPlugin.hide();
        this._continueCallback = onContinueCallBack;
        this.visible = true;
        this.onOrientationChanged();
        const tl = new TimelineLite();
        tl.add([
            DeadwoodRip.background.dimScreen(0.7, 0.4, this._layer),
            this.getShowAnimations()
        ]);
        tl.add(() => {
            this._continueButton.visible = true;
            this._continueButton.enable(true);
        });

        return tl;
    }

    protected abstract getShowAnimations():TimelineLite;

    protected close():TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            DeadwoodRip.background.dimScreen(0, 0.5),
            gsap.to(this, {duration : 1, alpha : 0}),
            () => {
                this._continueButton.visible = false;
                this._continueButton.enable(false);
            }
        ])
        tl.add(() => {
            SlotGame.keypadPlugin.show();
            this.visible = false;
            this.alpha = 1;
        });

        return tl;
    }
}